export default (url, width, height) => {
  window.open(url, 'targetWindow', `toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=${width}, height=${height}`)
}
